import { Grid } from '@factorialco/deprecated-design-system'
import {
  ContractVersionPageContractDataFragment,
  ContractVersionPageContractVersionFragment,
  ContractVersionsPageEmployeeActivityFragment,
  ContractsEmployeesContractVersionFragment,
} from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import { isBackendDateTimeInFuture, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'

import ActivityStart from './ActivityStart'
import ContractStatus from './ContractStatus'
import DaysActive from './DaysActive'
import TotalDaysActive from './TotalDaysActive'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
  contractVersionPolicies: ContractsEmployeesContractVersionFragment['_policies']
  employeeActivity?: ContractVersionsPageEmployeeActivityFragment | undefined
  contractData?: ContractVersionPageContractDataFragment | undefined | null
}

const FixDiscontinuous = ({
  contractVersion,
  contractVersionPolicies,
  employeeActivity,
  contractData,
}: Props) => {
  const canEdit = contractVersionPolicies?.edit?.can ?? false
  const canSeeEndDate = contractVersionPolicies?.seeEndDate?.can ?? false
  const canSeeStartDate = contractVersionPolicies?.seeStartDate?.can ?? false
  const showWidget = (canSeeStartDate && canSeeEndDate) || canEdit
  const contractStatus = contractData?.status
  const selectedPeriod = contractData?.activityPeriods
    ?.find((period) => contractVersion.id && period.contractVersionIds.includes(contractVersion.id))
    ?.periods.find((period) => period.contractVersionId === contractVersion.id)
  const isUpcoming =
    contractData?.schedule === 'upcoming' || selectedPeriod?.schedule === 'upcoming'

  if (!showWidget) {
    return null
  }

  const contractActivities = employeeActivity?.contractActivities.filter(
    (activity) => !isBackendDateTimeInFuture(activity.startDate)
  )
  const sortedActivities = sortBy(contractActivities, 'startDate')
  const currentActivity = sortedActivities[sortedActivities.length - 1]
  const startsOnDate = currentActivity?.startDate
    ? stringToDate(currentActivity.startDate, 'backend')
    : null

  const effectiveDate = contractVersion.effectiveOn
    ? stringToDate(contractVersion.effectiveOn, 'backend')
    : null
  const endDate = contractVersion.endsOn ? stringToDate(contractVersion.endsOn, 'backend') : null

  return (
    <Section icon="contract" title={i18n.t('contract_versions.fix_discontinuous.title')}>
      <Grid variant="fixed">
        <ContractStatus contractStatus={contractStatus} isUpcoming={isUpcoming} />
        <ActivityStart
          isActive={contractData?.status?.isActive || false}
          effectiveDate={effectiveDate}
          endDate={endDate}
        />
        <TotalDaysActive daysCount={employeeActivity?.activeDaysCount} startDate={startsOnDate} />
        <DaysActive contractActivity={currentActivity} />
      </Grid>
    </Section>
  )
}

export default FixDiscontinuous
